
exports.Dialog = function(options){
  return {
    template: require("./dialog/index.pug")(),
    controller: require("./dialog/"),
    plain: true,
    disableAnimation: true,
    className: "ngdialog-theme-default category-dialog",
    trapFocus: false,
    closeByDocument: false,
    resolve: {
      options: function(){ return options }
    }
  }
}
